/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import axios from 'axios';
import { getResponseDetails } from './ErrorCodes';

class interfaceService {

    /**
     * 
     * Called this method after success response came from axios 
     * 
     * @param response 
     * @returns response
     */
    handleSuccess(response) {
        return response;
    };

    /**
     * 
     * Called when error response came from axios
     * 
     * @param error 
     * @returns return error. E.g {messgae: 'internal server error'}.
     */
    handleError = (error) => {
        try {
            const return_data = {};
            if (error.response) {
                if (error.response.data.message instanceof Array) {
                    return_data['message'] = `${error.response.data.message[0]['message']}`;
                } else {
                    return_data['message'] = `${error.response.data.message ? error.response.data.message : getResponseDetails(error.response.status)}`;
                }

                if (error.response.data.code) {
                    return_data['code'] = error.response.data.code;
                }

                if (error?.response?.data?.error?.data) {
                    return_data['error'] = error.response.data.error;
                }
            } else if (error.request) {
                const message = error?.message ?
                    error.message : error?.request?.statusText ?
                        error.request.statusText : error?.request?.responseTex ?
                            error.request.responseTex : "Network Error";
                return_data['message'] = message;
            } else {
                return_data['message'] = `${error.message}`;
            }
            if (error.response?.status) {
                return_data['status'] = error.response.status;
            }
            console.clear();
            setTimeout(() => { console.clear(); }, 1000);
            return Promise.reject(return_data);
        } catch (error) {
            console.clear();
            setTimeout(() => { console.clear(); }, 1000);
            return Promise.reject(error);
        }

    }

    /**
     * 
     * @returns Interface service
     */
    getService() {
        let service = axios.create();
        service.interceptors.response.use(this.handleSuccess, this.handleError);
        return service;
    }
}

export default new interfaceService();